<script setup lang="ts">
/**
 * "Prices in BRL (Brazilian real)" — stated once, wherever the checkout shows
 * money the customer is about to commit to. See `useBillingCurrency` for why a
 * currency symbol alone is not enough.
 */
const { code, name } = useBillingCurrency()
</script>

<template>
  <p class="text-xs text-muted flex items-start gap-1.5">
    <UIcon name="i-lucide-banknote" class="size-3.5 shrink-0 mt-px" />
    <span>{{
      $t('billing.page.checkout.summary.currencyNote', {
        code,
        name,
      })
    }}</span>
  </p>
</template>
